import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import './assets/tailwind.css';
import { initTranslations } from './i18n';
import { getLangFromRoute } from './shared/languageHelpers';

Vue.use(Vue2TouchEvents);
Vue.use(
  VueGtag,
  {
    bootstrap: false,
  },
  router
);
Vue.config.productionTip = false;

// Asynchronously load translations before initializing Vue
initTranslations(getLangFromRoute(window.location.pathname)).then(i18n => {
  new Vue({
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app');
});
